"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appManifestReducers = void 0;
const appManifestSlice_1 = require("../../ui/stores/appManifestSlice");
exports.appManifestReducers = {
    appManifest: appManifestSlice_1.appManifestSlice.reducer,
};
